<template>
    <div>
        <page-header :title="title" :items="items" />
        <div class="row">
            <div v-if="currentContentComponent.key" class="col-12">
                <edit-content
                    :current-content-component="currentContentComponent"
                />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import EditContent from '@/components/contents/Edit';

export default {
    page: {
        title: 'Contents'
    },

    components: {
        EditContent
    },

    data() {
        return {
            title: 'Contents',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Contents',
                    to: '/contents'
                }
            ],
            currentContentComponent: {}
        };
    },

    async created() {
        try {
            const contents = await this.getContents();

            const { key: currentKey } = this.$route.params;

            const currentItem = contents.find(
                item => item.key === _.camelCase(currentKey)
            );

            this.currentContentComponent = { ...currentItem };
            this.title = this.currentContentComponent.name;

            this.items = [
                ...this.items,
                { text: this.currentContentComponent.name, active: true }
            ];
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getContents: 'contents/index'
        })
    }
};
</script>
